import createReducer from '../utils/createReducer';

const INITIAL = null;

export default createReducer('gymClassCategories', INITIAL, {
  set: (state, payload) => payload,
});
